import React from "react";
import { Helmet } from "react-helmet";

const RefundAndCancellation = () => {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://petqura.com/refund-and-cancellation"
        />
      </Helmet>
      <div className="common-container custom-refund-container mb-100">
        <div className="responsive-policy-content">
          <h2 className="ml-5">CANCELLATION AND REFUND POLICY</h2>
          <p>
            Cancellations must be made through the app/website before the
            appointment start time.
          </p>
          <ul>
            <li>
              <p>
                120 minutes or more before the appointment: 100% refund of
                the consultation fee paid.
              </p>
            </li>
            <li>
              <p>
                Less than 120 minutes but at least 60 minutes before: 70%
                refund (30% of the consultation fee is retained).
              </p>
            </li>
            <li>
              <p>
                Less than 60 minutes before: 50% refund (50% of the
                consultation fee is retained).
              </p>
            </li>
            <li>
              <p>
                No-show or cancellation after the appointment start time: No
                refund.
              </p>
            </li>
            <li>
              <p>
                Clinic cancellations: If the clinic or platform cancels or
                cannot honour the appointment, you will receive a 100%
                refund or the option to rebook at no charge.
              </p>
            </li>
          </ul>
          <p>
            Refunds are processed to your original payment method within 5-7
            business days. Payment gateway charges, if any, are
            non-refundable.
          </p>
        </div>
      </div>
    </>
  );
};

export default RefundAndCancellation;
